import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { IconChevronRight } from '@travel-frontend/icons';
import { Trans, useTranslation } from 'next-i18next';
import a3mImage from '../../assets/images/A3M-banner.svg';
import { Container } from '../../components/A3MBanner/components/Container.js';
import { Content } from '../../components/A3MBanner/components/Content.js';
import { Image } from '../../components/A3MBanner/components/Image.js';
import { LinkChevron } from '../../components/A3MBanner/components/LinkChevron.js';
import { Text } from '../../components/A3MBanner/components/Text.js';
import { Title } from '../../components/A3MBanner/components/Title.js';
import { Link } from '../../primitives/index.js';
import { A3M_BANNER_QA_ID, qaId } from '../../utils/qaId.js';
const LinkContainer = Container.withComponent(Link, process.env.NODE_ENV === "production" ? {
  target: "e1oiuo6t0"
} : {
  target: "e1oiuo6t0",
  label: "LinkContainer"
});
export const A3MBanner = ({
  country,
  countryLink,
  transitCountryLink
}) => {
  const transitCountry = Boolean(transitCountryLink) && countryLink !== transitCountryLink;
  const mdUp = useBreakpointUp('md');
  const lgUp = useBreakpointUp('lg');
  const {
    t
  } = useTranslation('a3MBanner');
  const title = _jsx(Trans, {
    i18nKey: "a3MBanner:title",
    values: {
      country
    },
    context: mdUp ? transitCountry ? 'transit' : '' : 'sm',
    components: [_jsx(Link, {
      href: countryLink,
      rel: "nofollow noreferrer",
      target: "_blank"
    }, "countryLink")]
  });
  return transitCountry ? _jsxs(Container, {
    "data-testid": qaId(A3M_BANNER_QA_ID),
    children: [_jsx(Image, {
      src: a3mImage,
      alt: "",
      hasTransitCountry: transitCountry
    }), _jsxs(Content, {
      children: [_jsxs("div", {
        children: [_jsx(Title, {
          children: title
        }), lgUp && _jsx(Text, {
          children: t('text')
        }), _jsx(Text, {
          children: _jsx(Trans, {
            i18nKey: "a3MBanner:transitCountry",
            context: mdUp ? '' : 'sm',
            components: [_jsx(Link, {
              size: mdUp ? 'medium' : 'small',
              href: transitCountryLink,
              rel: "nofollow noreferrer",
              target: "_blank"
            }, "transitCountryLink")]
          })
        })]
      }), _jsx(LinkChevron, {
        href: countryLink,
        target: "_blank",
        children: _jsx(IconChevronRight, {})
      })]
    })]
  }) : _jsxs(LinkContainer, {
    href: countryLink,
    target: "_blank",
    "data-testid": qaId(A3M_BANNER_QA_ID),
    children: [_jsx(Image, {
      src: a3mImage,
      alt: "",
      hasTransitCountry: transitCountry
    }), _jsxs(Content, {
      children: [_jsxs("div", {
        children: [_jsx(Title, {
          children: title
        }), mdUp && _jsx(Text, {
          children: t('text')
        })]
      }), _jsx(IconChevronRight, {})]
    })]
  });
};